import { Flame, ShieldCheck, Handshake, Scale, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const VALUES = [
  { icon: Handshake, title: "Service", text: "Leadership that shows up for every ward, every village, every person." },
  { icon: Scale, title: "Integrity", text: "Public resources guarded like family property — accounted for, always." },
  { icon: Users, title: "Inclusion", text: "No one left behind: youth, women, elders and persons with disabilities." },
];

export const PartySection = () => (
  <section id="movement" data-testid="party-section" className="py-24 sm:py-36 bg-[#1E3E2B]/25 border-y border-white/5">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="eyebrow mb-4" data-testid="party-eyebrow">Party &amp; Movement</p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] max-w-3xl">
          Orange roots. <span className="text-orange-500">A citizen-first movement.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-5">
        <Reveal delay={0.08}>
          <div className="bento-card h-full" data-testid="party-odm-card">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-xl bg-orange-600/15 border border-orange-500/40 flex items-center justify-center">
                <Flame size={20} className="text-orange-500" />
              </span>
              <p className="mono text-[11px] tracking-[0.25em] uppercase text-orange-400">Party Ticket</p>
            </div>
            <h3 className="font-display font-bold text-2xl mt-6">Orange Democratic Movement</h3>
            <p className="text-stone-400 text-base leading-relaxed mt-3">
              Elected to Parliament three consecutive times on the ODM ticket,
              Wanyonyi carries the party's social-democratic tradition of justice,
              devolution and opportunity for ordinary Kenyans.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.16}>
          <div className="bento-card h-full" data-testid="party-linda-mwananchi-card">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-xl bg-[#1E3E2B]/60 border border-emerald-700/50 flex items-center justify-center">
                <ShieldCheck size={20} className="text-emerald-400" />
              </span>
              <p className="mono text-[11px] tracking-[0.25em] uppercase text-emerald-400">Movement</p>
            </div>
            <h3 className="font-display font-bold text-2xl mt-6">Linda Mwananchi</h3>
            <p className="text-stone-400 text-base leading-relaxed mt-3">
              Aligned with the Linda Mwananchi movement alongside leaders like
              Senator Edwin Sifuna — a citizen-first platform defending rights,
              public resources and economic fairness for wananchi.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="mt-5 grid sm:grid-cols-3 gap-5" data-testid="party-values-row">
        {VALUES.map((v, i) => (
          <Reveal key={v.title} delay={0.1 + i * 0.08}>
            <div className="bento-card h-full" data-testid={`party-value-${v.title.toLowerCase()}`}>
              <v.icon size={20} className="text-orange-500" />
              <h4 className="font-display font-semibold text-xl mt-4">{v.title}</h4>
              <p className="text-sm text-stone-400 leading-relaxed mt-2">{v.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
